import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from "./helpers";
import { Globals } from "./globals"
import * as CryptoJS from 'crypto-js';

declare var swal: any;
@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    title = 'app';
    globalBodyClass = 'm-page--loading-non-block m-page--fluid m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';
    private _urlTokenRefresh: string = '/user/tokenrefresh';
    encrypt: string;
    decrypt: string;
    constructor(private _router: Router, private _global: Globals) {
    }

    ngOnInit() {
        this._router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                Helpers.setLoading(true);
                Helpers.bodyClass(this.globalBodyClass);
            }
            if (route instanceof NavigationEnd) {
                Helpers.setLoading(false);
            }
        });
        //Todo: Funcion para reconectar usuario con refrestoken
        setInterval(() => {
            this.encrypt = localStorage.getItem('auth');
            this.decrypt = CryptoJS.AES.decrypt(this.encrypt, this._global.key_aes).toString(CryptoJS.enc.Utf8);
            let auth: any = JSON.parse(this.decrypt);
            let dataUser = JSON.parse(localStorage.getItem('currentUser'));
            let response: any = this._global.getJSON(this._urlTokenRefresh, { email: auth.email, password: auth.password, token2: dataUser.refresh_token }, 'POST');
            if (response.result == 'success') {
                localStorage.removeItem('currentUser');
                localStorage.setItem('currentUser', JSON.stringify(response.payload));
            } else {
                localStorage.clear();
                this._router.navigate(['/login']);
                swal('Sesión', "Su tiempo de conexión a caducado", 'info');
            }
        }, 118000);
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts